import React from 'react';
import { Loader2 } from 'lucide-react';

export const resultTone = (r) => {
  if (!r) return 'idle';
  if (r.status === 'Accepted') return 'ok';
  return r.status === 'ValidationError' ? 'warn' : 'bad';
};

const PILL = {
  ok: 'bg-[#E6F2E9] text-[#2f6b41]',
  bad: 'bg-[#FBE7E4] text-[#9b2c1f]',
  warn: 'bg-[#FBF0DC] text-[#8a5a12]',
  idle: 'bg-[#F3EFE2] text-[#7a6f5c]',
};
const LABEL = { ok: 'Passes all checks', bad: 'Will be rejected', warn: 'Validation error', idle: 'Checking…' };

export const CartValidationHead = () => (
  <>
    <th className="px-4 py-3 font-medium">Cooling</th>
    <th className="px-4 py-3 font-medium">Last delivery</th>
    <th className="px-4 py-3 font-medium">Next eligible</th>
    <th className="px-4 py-3 font-medium">Validation</th>
  </>
);

export function CartValidationCells({ sku, result, checking }) {
  const tone = resultTone(result);
  const cooling = result?.coolingActive === false || result?.coolingDays === 0 ? 'Off' : result?.coolingDays != null ? `${result.coolingDays} days` : '—';
  return (
    <>
      <td className="px-4 py-3 whitespace-nowrap text-[12.5px]">{cooling}</td>
      <td className="px-4 py-3 whitespace-nowrap text-[12.5px]" data-testid={`req-cart-last-delivery-${sku}`}>{result?.lastDeliveredDate || '—'}</td>
      <td className="px-4 py-3 whitespace-nowrap text-[12.5px]" data-testid={`req-cart-next-eligible-${sku}`}>{result?.nextEligibleDate || '—'}</td>
      <td className="px-4 py-3 min-w-[190px]">
        <span data-testid={`req-cart-validation-${sku}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11.5px] font-medium ${PILL[tone]}`}>
          {checking && tone === 'idle' && <Loader2 size={11} className="animate-spin" />}{LABEL[tone]}
        </span>
        {result && tone !== 'ok' && <div className="text-[11.5px] mt-1" style={{ color: tone === 'warn' ? '#8a5a12' : '#9b2c1f' }} data-testid={`req-cart-reason-${sku}`}>{result.title}</div>}
      </td>
    </>
  );
}
